import { useQuery } from '@tanstack/vue-query';

type VideoTestimonial = {
  mediaType: 'hls';
  title?: string;
  description?: string;
  createdAt?: string;
  badge?: string;
  mediaUrl?: string;
  image?: {
    src?: string;
    alt?: string;
  };
};

type TextTestimonial = {
  mediaType: 'text';
  title?: string;
  description?: string;
  author?: string;
  subheading?: string;
  createdAt?: string;
  badge?: string;
  image?: {
    src?: string;
    alt?: string;
  };
};

export type Testimonial = VideoTestimonial | TextTestimonial;

export const useTestimonials = () => {
  const {
    data: testimonials,
    error,
    isLoading,
  } = useQuery({
    queryKey: ['testimonials'],
    queryFn: async (): Promise<Testimonial[]> => {
      const results = await queryCollection('testimonials')
        .select(
          'mediaType',
          'title',
          'description',
          'author',
          'subheading',
          'badge',
          'mediaUrl',
          'createdAt',
          'image'
        )
        .order('createdAt', 'DESC')
        .all();

      return results as Testimonial[];
    },
  });

  return {
    testimonials,
    error,
    isLoading,
  };
};
